import { render, staticRenderFns } from "./AvoidFoodDialog.vue?vue&type=template&id=dd4ab3ee&scoped=true"
import script from "./AvoidFoodDialog.vue?vue&type=script&lang=js"
export * from "./AvoidFoodDialog.vue?vue&type=script&lang=js"
import style0 from "./AvoidFoodDialog.vue?vue&type=style&index=0&id=dd4ab3ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4ab3ee",
  null
  
)

export default component.exports